import { useGetAllTasksByEntityQuery } from "store/apis/filing";
import { TaskListBaseQueryParams } from "types/Models/task";
import { TaskTableBodyPerSeason } from "./TaskTableBodyPerSeason";

export const TaskTableBodyPerSeasonWrapper = ({
  entityId,
  season,
  isParentFetching,
  params,
}: {
  entityId: string;
  season: string;
  isParentFetching: boolean;
  params: TaskListBaseQueryParams;
}) => {
  const { data, isLoading, isSuccess } = useGetAllTasksByEntityQuery(
    {
      ...params,
      filing_season: season,
      entity_id: entityId,
    },
    {
      skip: !season || !entityId,
    }
  );

  return (
    <TaskTableBodyPerSeason
      key={season}
      isFetching={isParentFetching || isLoading || !isSuccess}
      season={season.toString()}
      tasks={data?.tasks || []}
    />
  );
};
